import { c as _c } from "react/compiler-runtime";
import type { PiiJsonValue } from '@onefootprint/request-types';
import { MarkdownText, SegmentedControl } from '@onefootprint/ui';
import isObject from 'lodash/isObject';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PrettyJsonVisualizer from '@/components/pretty-json-visualizer/pretty-json-visualizer';
import jsonToMd from '../../../../utils/json-to-md';
type GenericOutputViewProps = {
  output: PiiJsonValue;
  showJsonView?: boolean;
};
const getJsonString = (output: PiiJsonValue) => {
  try {
    if (isObject(output)) {
      return JSON.stringify(output, null, 2);
    }
    if (typeof output === 'string') {
      const parsed = JSON.parse(output);
      if (isObject(parsed)) {
        return JSON.stringify(parsed, null, 2);
      }
    }
  } catch {
    return null;
  }
  return null;
};
const GenericOutputView = t0 => {
  const $ = _c(24);
  const {
    output,
    showJsonView: t1
  } = t0;
  const showJsonView = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "agentExecutionSummary.genericOutputView"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  const [viewType, setViewType] = useState("formatted");
  let t3;
  let t4;
  if ($[1] !== output || $[2] !== showJsonView || $[3] !== t || $[4] !== viewType) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const jsonString = getJsonString(output);
      if (!jsonString) {
        const t5 = String(output);
        let t6;
        if ($[7] !== t5) {
          t6 = <div className="text-body-2 text-secondary">{t5}</div>;
          $[7] = t5;
          $[8] = t6;
        } else {
          t6 = $[8];
        }
        t4 = t6;
        break bb0;
      }
      if (!showJsonView) {
        t4 = <MarkdownText>{jsonToMd(jsonString) ?? ""}</MarkdownText>;
        break bb0;
      }
      let t5;
      if ($[9] !== t) {
        t5 = t(_temp);
        $[9] = t;
        $[10] = t5;
      } else {
        t5 = $[10];
      }
      let t6;
      if ($[11] !== t5) {
        t6 = {
          label: t5,
          value: "formatted"
        };
        $[11] = t5;
        $[12] = t6;
      } else {
        t6 = $[12];
      }
      let t7;
      if ($[13] !== t) {
        t7 = t(_temp2);
        $[13] = t;
        $[14] = t7;
      } else {
        t7 = $[14];
      }
      let t8;
      if ($[15] !== t7) {
        t8 = {
          label: t7,
          value: "json"
        };
        $[15] = t7;
        $[16] = t8;
      } else {
        t8 = $[16];
      }
      let t9;
      if ($[17] !== t6 || $[18] !== t8) {
        t9 = [t6, t8];
        $[17] = t6;
        $[18] = t8;
        $[19] = t9;
      } else {
        t9 = $[19];
      }
      let t10;
      if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = value => setViewType(value as 'formatted' | 'json');
        $[20] = t10;
      } else {
        t10 = $[20];
      }
      let t11;
      if ($[21] !== t9 || $[22] !== viewType) {
        t11 = <SegmentedControl size="compact" aria-label="View type" options={t9} value={viewType} onChange={t10} />;
        $[21] = t9;
        $[22] = viewType;
        $[23] = t11;
      } else {
        t11 = $[23];
      }
      t3 = <div className="flex flex-col gap-4">{t11}{viewType === "formatted" ? <MarkdownText>{jsonToMd(jsonString) ?? ""}</MarkdownText> : <PrettyJsonVisualizer json={jsonString} />}</div>;
    }
    $[1] = output;
    $[2] = showJsonView;
    $[3] = t;
    $[4] = viewType;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  return t3;
};
export default GenericOutputView;
function _temp($) {
  return $.viewType.formatted;
}
function _temp2($_0) {
  return $_0.viewType.json;
}